import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=d93f9f76&scoped=true&"
import script from "./customer.vue?vue&type=script&lang=js&"
export * from "./customer.vue?vue&type=script&lang=js&"
import style0 from "./customer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./customer.vue?vue&type=style&index=1&id=d93f9f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93f9f76",
  null
  
)

export default component.exports